<!-- <app-loader></app-loader> -->
  <div>
    <div class="modal-header">
      <h4 class="modal-title pull-left">
        <i class="fa fa-plus" *ngIf="initialData?.isEdit != true"></i>
        <i class="fa fa-pencil" *ngIf="initialData?.isEdit == true"></i>
        {{ initialData?.isEdit == true ? "Edit License": "Create License" }}
      </h4>
      <i
        class="fa fa-close popup-close small"
        aria-hidden="true"
        title="Close"
        (click)="modalRef.hide()"
      ></i>
    </div>
  
    <div class="modal-body">
      <div class="form-group">
        <label class="label-font" for="code">Code</label
        ><span class="required">*</span>
        <input
          id="code"
          class="form-control"
          type="text"
          placeholder="Customer Code"
          [ngModel]="model.code | uppercase" 
          (ngModelChange)="onCustomerCodeChange($event)"
          [attr.readonly]="initialData?.isEdit" maxlength="50"
        />
      </div>
      <div class="form-group">
        <label class="label-font" for=""
          >License Type<span class="required">*</span></label
        >
  
        <mat-select
          class="form-control"
          id="licenseType"
          [(ngModel)]="model.licenseType"
          type="text" (ngModelChange)="onLicenseTypeChange($event)"
          placeholder="--Select--"
        >
          <mat-option
            *ngFor="let item of licenseList"
            placeholder="Select License"
            [value]="item.value"
          >
          {{ item.displayValue }}</mat-option
          >
        </mat-select>
      </div>
      <div class="row">
        <section class="col-md-6">
            <span >
            <mat-checkbox [(ngModel)]="model.scriptlesscheck" (ngModelChange)="onCheckboxChange($event, 'QE360SCRIPTLESS')">
                QE360 Scriptless
            </mat-checkbox>
            </span>
        </section>
        <section class="col-md-6">
            <span >
            <mat-checkbox [(ngModel)]="model.scriptedcheck" (ngModelChange)="onCheckboxChange($event, 'QE360SCRIPTED')">
                QE360 Scripted
            </mat-checkbox>
            </span>
        </section>
      </div>
      <div class="row form-group">
        <section class="col-md-6">
            <span >
            <mat-checkbox [(ngModel)]="model.randomTestDataCheck" (ngModelChange)="onCheckboxChange($event, 'RANDOMTESTDATA')" [disabled]="!model.scriptlesscheck">
                Random Test Data
            </mat-checkbox>
            </span>
        </section>
        <section class="col-md-6">
            <span >
            <mat-checkbox [(ngModel)]="model.designCoPilotCheck" (ngModelChange)="onCheckboxChange($event, 'DESIGNCOPILOT')" [disabled]="!model.scriptlesscheck">
                Design Copilot
            </mat-checkbox>
            </span>
        </section>
      </div>
      <div
        class="form-group col-lg-12 col-md-12"
        style="display: flex; margin-top: 1rem"
      >
      
        <div class="col-sm-5 nopadding">
          <label class="label-font">Available Utilities</label>
          
           <div>
            <!-- <div class="subloader" *ngIf="preloader"></div> -->
           
           </div>
         <!-- <select *ngIf="!preloader" -->
           <select
            multiple
            name="selectedUtilities"
            style="width: 100%; height: 110px; border-color: #49505740"
            ng-multiple="true"
            [(ngModel)]="utilityLeftValues"
          >
  
             <option
              *ngFor="let utilityName of utilityList"
              [ngValue]="utilityName"
            >
              {{ utilityName.name }}
            </option>
          </select>
        </div>
        <div class="col-sm-2 text-center chooden">
            <button
              class="btn btn-default chooden-btn"
              (click)="rightAppPressed()"
              style="color: #fff"
            >
              <i class="fa fa-arrow-right" aria-hidden="true"></i>
            </button>
            <button
              (click)="leftAppPressed()"
              class="btn btn-default chooden-btn"
              style="color: #fff"
            >
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
            </button>
          </div>
          <div class="col-sm-5 nopadding">
            <label class="label-font">Assigned Utilities</label>
            <div>
              <!-- <div class="subloader" *ngIf="preloader"></div> -->
    
             </div>
            
            <!-- <select *ngIf="!preloader" -->
            <select
              multiple
              name="selectedUtilities"
              style="width: 100%; height: 110px; border-color: #49505740"
              ng-multiple="true"
              [(ngModel)]="utilitiesRightValues"
            >
              <option
                *ngFor="let utility of utilityRightList"
                [ngValue]="utility"
              >
                {{ utility.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
            <div class="form-group col-sm-6">
                <label class="label-font" for="">Start Date<span class="required">*</span></label>
                <div class="input-group">
                    <mat-form-field appearance="fill">
                    <input
                        matInput
                        [matDatepicker]="startPicker"
                        [(ngModel)]="model.startDate"
                        placeholder="Data 1"
                        placeholder="DD/MM/YYYY" [min]="minDate" (dateChange)="onStartDateChange($event)"
                    />
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="startPicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #startPicker> </mat-datepicker>
                    </mat-form-field>
        
                </div>
            </div>
            <div class="form-group col-sm-6">
                <label class="label-font" for="">End Date<span class="required">*</span></label>
                <div class="input-group">
                    <mat-form-field appearance="fill">
                    <input
                        matInput
                        [matDatepicker]="endPicker"
                        [(ngModel)]="model.endDate"
                        placeholder="Data 2"
                        placeholder="DD/MM/YYYY" [min]="minDate" [disabled]="model.licenseType?.toLowerCase() == 'trial'"
                    />
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="endPicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #endPicker> </mat-datepicker>
                    </mat-form-field>
        
                </div>
            </div>
        </div>
        <div class="form-group">
          <label class="label-font" for="userName">Instance Type</label>
          <span class="required">*</span>
          <div>
            <mat-radio-group [(ngModel)]="instanceType">
              <mat-radio-button title="'Cloud'"  [value]="'CLOUD'">
                Cloud&nbsp;
              </mat-radio-button>
              <mat-radio-button title="'On Premise'"  [value]="'ON PREM'">
                On Premise&nbsp;
              </mat-radio-button>
            </mat-radio-group>
          </div>
      </div>
      <div class="form-group">
        <label class="label-font" for="userName">User Count</label>
        <span class="required">*</span><input
          id="userCount"
          class="form-control"
          type="number"
          placeholder="User Count"
          [(ngModel)]="model.userCount" (ngModelChange)="onUserCountChange($event)" min="0" [disabled]="model.licenseType?.toLowerCase() == 'trial'"
        />
    </div>
    </div>
  
    <div class="modal-footer">
        <div class="left-aligned">Total Cost <br />${{model.totalCost}}</div>
       <button
        class="btn btn-success foot__btns ng-binding"
        (click)="save()"
      >
        <i class="fa fa-floppy-o" aria-hidden="true"></i>Save
      </button>
      <button (click)="modalRef.hide()" class="btn btn-danger foot__btns">
        <i class="fa fa-ban" aria-hidden="true"> </i>
        Cancel
      </button>
    </div>
  </div>